var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgHeartIconSolid = function SvgHeartIconSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 15,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EF2929",
    fillRule: "evenodd",
    d: "M1.415 1.448a4.752 4.752 0 0 1 6.832 0L9 2.22l.753-.772a4.752 4.752 0 0 1 6.832 0c1.887 1.932 1.887 5.063 0 6.994l-5.573 5.705a2.8 2.8 0 0 1-4.024 0L1.415 8.442c-1.887-1.931-1.887-5.062 0-6.994Z",
    clipRule: "evenodd"
  })));
};
export default SvgHeartIconSolid;